import { ListItem, Stack, Typography, Box } from "@mui/material";
import { useState } from "react";
import "styles/sidenav.scss";

const ChannelButton = ({ channel, selectedChannel, clickHandler, disabled, notifications }) => {
  // const isMobileDisplay = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  const [isHovered, setIsHovered] = useState(false);
  const isSelected = channel.key === selectedChannel.key;
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <ListItem
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`hub-channel-button ${disabled ? "disabled" : ""}`}
      onClick={() => {
        if (!disabled) {
          clickHandler(channel);
        }
      }}
    >
      <Stack width="100%" alignItems="center" position="relative">
        <Box
          className={`hub-channel-button-icon ${isSelected ? "selected" : ""}`}
          sx={{
            background: isHovered && !isSelected && !disabled && "#28282a",
            color: isSelected && channel.selectedColor,
            position: "relative",
          }}
        >
          {channel.icon}
          {notifications && notifications > 0 ? (
            <Box
              className="sidenav-notification-bubble"
              sx={{
                top: "6px",
                right: "0px",
                backgroundColor: channel.selectedColor,
              }}
            >
              <Typography variant="body2" fontSize="10px" fontWeight="bold">
                {notifications}
              </Typography>
            </Box>
          ) : null}
        </Box>
        <Typography className="hub-channel-button-name">{channel.displayName}</Typography>
        {disabled && (
          <Typography className="hub-channel-button-coming-soon">Coming Soon!</Typography>
        )}
      </Stack>
    </ListItem>
  );
};

export default ChannelButton;
